import { IGroupMatches } from "@grassrootly/api/entities/IGroupsMatches";
import withErrorCheck from "../CheckError";
import server from "../Server";

export interface GroupMatchesParams {
  date_to: string;
  grid: number;
  pid: number;
  limit?: number;
  offset?: number;
}

export const GetGroupMatches = async ({ 
  date_to, 
  grid, 
  pid, 
  limit = 10, 
  offset = 0 
}: GroupMatchesParams): Promise<IGroupMatches[]> => {
  // @ts-ignore
  let query = server.rpc("players_group_previous_games", { date_to, grid, pid });
  
  // Add pagination
  query = query.range(offset, offset + limit - 1);
  
  const groupMatches = withErrorCheck(await query);

  if (!groupMatches) return [];

  return groupMatches;
};
